import React from 'react'
import { Icon } from '../../../atoms'

export interface ITooltipPlatinumProps {
  triggerElementId: string
  title: string
  content: string
}

const TooltipPlatinum: React.FC<ITooltipPlatinumProps> = ({
  title,
  content,
  triggerElementId,
}: ITooltipPlatinumProps) => {
  return (
    <div data-controller='platinum-tooltip'>
      <div className='TooltipPlatinum' data-trigger-element-id={triggerElementId}>
        <div className='TooltipPlatinum__mask' role='dialog' data-tooltip-mask />
        <div className='TooltipPlatinum__modal' role='tooltip'>
          <div className='TooltipPlatinum__modal-header'>
            <div className='TooltipPlatinum__modal-header-title'>{title}</div>
            <div
              className='TooltipPlatinum__close'
              data-tool-tip-close
              data-action='click->platinum-tooltip#closeModal'
            >
              <Icon glyph={'cross'} size={32} color='#34454E' />
            </div>
          </div>
          <div className='TooltipPlatinum__modal-content'>{content}</div>
        </div>
      </div>
    </div>
  )
}

export default TooltipPlatinum
